import { Form } from "antd";
import { Rule } from "antd/es/form";

import { INPUT_MAX_LENGTH, MarkdownField } from "@/ui-components/commonComponents/MarkdownField/MarkdownField";
import {
  TextLocationHelperText,
  TextLocations,
} from "@/modules/assessments/scenes/CreateAssessment/createAssessment.constants";
import { localeLabel } from "@/shared/utils/locale.utils";

import style from "./style.module.css";
import "./index.css";

function LocaleTextEditor({
  location,
  locale,
  isChangeable,
  rules,
  siblingLocales,
}: {
  location: TextLocations;
  locale: string;
  isChangeable: boolean;
  rules?: Rule[];
  siblingLocales: string[];
}) {
  const form = Form.useFormInstance();
  const value = Form.useWatch([location, locale], form) as string | undefined;

  return (
    <Form.Item
      className={style.mdEditor}
      data-length={`${(value ?? "").length} / ${INPUT_MAX_LENGTH}`}
      name={[location, locale]}
      rules={rules}
      // Re-validate against sibling locales (Intro/Outro are all-or-nothing).
      dependencies={siblingLocales.map((other) => [location, other])}
    >
      <MarkdownField
        disabled={!isChangeable}
        textareaProps={{ "aria-label": `${location} (${localeLabel(locale)})` }}
      />
    </Form.Item>
  );
}

export default function LocaleTextTabs({
  location,
  locales,
  activeLocale,
  isChangeable = true,
  rulesForLocale,
}: {
  location: TextLocations;
  locales: string[];
  activeLocale: string;
  isChangeable?: boolean;
  rulesForLocale?: (locale: string) => Rule[];
}) {
  return (
    <div className="inputTitle">
      <div className={style.fieldLabel}>{location}</div>
      {TextLocationHelperText[location] && <p className={style.helperText}>{TextLocationHelperText[location]}</p>}
      {locales.map((locale) => (
        <div key={locale} hidden={locale !== activeLocale}>
          <LocaleTextEditor
            location={location}
            locale={locale}
            isChangeable={isChangeable}
            rules={rulesForLocale?.(locale)}
            siblingLocales={locales.filter((other) => other !== locale)}
          />
        </div>
      ))}
    </div>
  );
}
